<!-- {{tableData3$ |async}} -->

@if (tableData$ | async){

<div class="card">

  @if (refresh$ | async){
  <p-toolbar styleClass="mt-6 p-10 bg-gray-100">
    <ng-template #start>

      <!-- @if (awaitingRefresh()){ -->
        <p-tag [severity]="awaitingRefresh()? 'danger' : 'success'">
          {{awaitingRefresh() && !isLoading() &&!pendingSave() ?  'New data incoming from server, local data may be out of date.' : 'Data Synched with server'}}
        </p-tag>
        <!-- @if (pendingSave()){
          <p-tag [severity]="'warn'" class="ml-8">
            Table was edited, pending save changes
          </p-tag>
        } -->

      <!-- } -->
    </ng-template>
    <ng-template #end>
      @if(isLoading()){
        <p-progress-spinner ariaLabel="loading" strokeWidth="5"  [style]="{ width: '30px', height: '30px' }"/>
    }
      @else if (awaitingRefresh()){
        <p-button [severity]="'danger'" (onClick)="refreshTable()" icon="pi pi-cloud-download" [rounded]="true" class="transition duration-300 ease-in-out hover:-translate-y-1 hover:scale-110"/>
      }
      <span class="font-semibold"> </span>
    </ng-template>
  </p-toolbar>
}
  <p-toast
    [showTransformOptions]="'translateY(100%)'"
    [showTransitionOptions]="'1000ms'"
    [hideTransitionOptions]="'1000ms'"
    [showTransformOptions]="'translateX(100%)'"
  />
  <p-table
    [value]="keyphrasextractionTableIncoming()"
    dataKey="id"
    editMode="row"
    [scrollable]="true"
    scrollHeight="600px"
    [rowHover]="true"
    rowGroupMode="rowspan"
    groupRowsBy="key_area"
    sortField="key_area"
    [(selection)]="selectedKeyPhrases"
    sortMode="multiple"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template #header>
      <tr>
        <!-- <th style="width: 3rem; max-width: 3rem"></th> -->
        <th class="table-header text-xl" >Key Area</th>
        <th class="table-header text-xl" >Definition (Gr)</th>
        <th class="table-header text-xl" >Definition (En)</th>
        <th class="table-header text-xl" >Key Phrase (Gr)</th>
        <th class="table-header text-xl" >Key Phrase (En)</th>
        <th style="width: 10%; color: #5861ff" class="table-header text-xl">Edit</th>
        <th style="width: 3rem; max-width: 3rem"><p-tableHeaderCheckbox /></th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-keyphrase
      let-rowIndex="rowIndex"
      let-rowgroup="rowgroup"
      let-rowspan="rowspan"
      let-editing="editing"
    >
      <tr [pEditableRow]="keyphrase">
        <!-- <td style="width: 3rem">
          <p-tableCheckbox severity="contrast" [value]="keyphrase"  />
        </td> -->
        <td
          *ngIf="rowgroup"
          [attr.rowspan]="rowspan"
          [ngClass]="{ 
            'row-changed': isRowChanged(keyphrase.key_phrase_gr), 
            'row-added': isRowAdded(keyphrase.key_phrase_gr) 
          }"
          style="text-align: center"
        >
          <p-cellEditor>
            <ng-template pTemplate="input">
            <p-select
              [options]="keyPhraseDict"
              appendTo="body"
              [(ngModel)]="keyphrase.key_area"
              [style]="{ width: '100%' }"
            />
          </ng-template>
            <ng-template pTemplate="output">
              <span class="font-semibold">{{ keyphrase.key_area }}</span>
            </ng-template>
          </p-cellEditor>
          <!-- <span class="font-semibold">{{ keyphrase.key_area }}</span> -->
        </td>
        <td *ngIf="rowgroup" [attr.rowspan]="rowspan" [ngClass]="{ 
            'row-changed': isRowChanged(keyphrase.key_phrase_gr), 
            'row-added': isRowAdded(keyphrase.key_phrase_gr) 
          }">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <!-- <input
                pInputText
                type="text"
                [(ngModel)]="keyphrase.key_area_gr_definition"
                required
              /> -->
              <textarea
              pTextarea
              fluid
              cols="20"
              rows="7"
              [(ngModel)]="keyphrase.key_area_gr_definition"
              required
            ></textarea>
            </ng-template>
            <ng-template pTemplate="output">
              <span class="text-sm">{{ keyphrase.key_area_gr_definition }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td *ngIf="rowgroup" [attr.rowspan]="rowspan" [ngClass]="{ 
            'row-changed': isRowChanged(keyphrase.key_phrase_gr), 
            'row-added': isRowAdded(keyphrase.key_phrase_gr) 
          }">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <!-- <input
                pInputText
                type="text"
                [(ngModel)]="keyphrase.key_area_en_definition"
                required
              /> -->
              <textarea
              pTextarea
              fluid
              cols="20"
              rows="7"
              [(ngModel)]="keyphrase.key_area_en_definition"
              required
            ></textarea>
            </ng-template>
            <ng-template pTemplate="output">
              <span class="text-sm">{{ keyphrase.key_area_en_definition }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td [ngClass]="{ 
            'row-changed': isRowChanged(keyphrase.key_phrase_gr), 
            'row-added': isRowAdded(keyphrase.key_phrase_gr) 
          }">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="text"
                [(ngModel)]="keyphrase.key_phrase_gr"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <span class="block">{{ keyphrase.key_phrase_gr}}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td [ngClass]="{ 
            'row-changed': isRowChanged(keyphrase.key_phrase_gr), 
            'row-added': isRowAdded(keyphrase.key_phrase_gr) 
          }">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="text"
                [(ngModel)]="keyphrase.key_phrase_en"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <span class="block">{{ keyphrase.key_phrase_en }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <!--Buttons-->
        <td>
          <div class="flex items-center justify-center gap-2">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(keyphrase)"
              text
              rounded
              severity="secondary"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(keyphrase)"
              text
              rounded
              severity="secondary"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(keyphrase, rowIndex)"
              text
              rounded
              severity="secondary"
            ></button>
          </div>
        </td>
        <td style="width: 3rem">
          <p-tableCheckbox severity="contrast" [value]="keyphrase" />
        </td>
      </tr>
    </ng-template>


  </p-table>
</div>
<p-toolbar styleClass="mt-6">
  <ng-template #start>
    <p-button
      class="mr-5 font-bold"
      severity="danger"
      label="Delete"
      icon="pi pi-trash"
      outlined
      (onClick)="deleteSelectedKeyPhrases()"
      [disabled]="!selectedKeyPhrases().length && !awaitingRefresh()"
    />
    <p-button
      [style]="{ 'background-color': '#5861ff' }"
      label="Add new"
      icon="pi pi-plus"
      class="mr-2"
      (onClick)="openNew()"
      [disabled]="awaitingRefresh()"
    />
    <p-button
      severity="success"
      [style]="{ 'margin-left': '.5em' }"
      label="Save Changes"
      [disabled]="disableSave()"
      (click)="saveChanges()"
      icon="pi pi-check"
    ></p-button>
    <!--[disabled]="!changedRows().length && !deletedRows().length || awaitingRefresh()"-->
  </ng-template>
  <ng-template #end>
    @if (changedRows().length > 0){
      <p-tag [severity]="changedRows().length > 0 ? 'warn' : 'info'" class="mr-4">
        {{ changedRows().length }} keyphrase(s) edited
      </p-tag>
    }
    @if (addedRows().length > 0){
      <p-tag [severity]="addedRows().length > 0 ? 'info' : 'info'" class="mr-4">
        {{ addedRows().length }} keyphrase(s) added
      </p-tag>
    }
    @if (deletedRows().length > 0){
      <p-tag [severity]="deletedRows().length > 0 ? 'danger' : 'info'">
        {{ deletedRows().length }} keyphrase(s) deleted
      </p-tag>
    }

    <span class="font-semibold"> </span>
  </ng-template>
</p-toolbar>
<p-dialog
  [visible]="addNewRowDialog()"
  [style]="{ width: '450px' }"
  header="New Key Phrase Details"
  [modal]="true"
>
  <ng-template #content>
    <div class="flex flex-col gap-6">
      <div>
        <label for="keyArea" class="block font-bold mb-3">Key Area</label>
        <p-select
          inputId="inventoryStatus"
          [options]="keyPhraseDict"
          optionLabel="label"
          [(ngModel)]="selectValue"
          placeholder="Select a Key Area"
          fluid
        />
        <small
          style="color: #ff7193"
          *ngIf="submitted() && !keyphraseRow().key_area"
          ><b>Key Area is required.</b></small
        >
      </div>
      <div>
        <label for="Definition_Gr" class="block font-bold mb-3"
          >Definition (Greek)</label
        >
        <textarea
          id="Definition_Gr"
          pTextarea
          required
          rows="5"
          cols="20"
          fluid
          #text2
          >{{ selectValueDefinitionGr() }}</textarea
        >
        <small
          style="color: #ff7193"
          *ngIf="submitted() && keyphraseRow()?.key_area_en_definition == ''"
          ><b>Definition (Gr) required.</b></small
        >
      </div>
      <div>
        <label for="Definition_En" class="block font-bold mb-3"
          >Definition (English)</label
        >
        <textarea
          id="Definition_En"
          pTextarea
          required
          rows="5"
          cols="20"
          fluid
          #text3
          >{{ selectValueDefinitionEn() }}</textarea
        >
        <small
          style="color: #ff7193"
          *ngIf="submitted() && keyphraseRow()?.key_area_en_definition == ''"
          ><b>Definition (En) required.</b></small
        >
      </div>

      <div>
        <label for="keyPhrases_Gr" class="block font-bold mb-3"
          >Key Phrases (Gr)</label
        >
        <textarea
          id="keyPhrases_Gr"
          pTextarea
          rows="3"
          required
          cols="20"
          fluid
          #text4
        ></textarea>
        <small
          style="color: #ff7193"
          *ngIf="submitted() && keyphraseRow()?.key_phrase_gr
          == ''"
          ><b>Key Phrase (Gr) required.</b></small
        >
      </div>

      <div>
        <label for="keyPhrases_En" class="block font-bold mb-3"
          >Key Phrases (En)</label
        >
        <textarea
          id="keyPhrases_En"
          pTextarea
          required
          rows="3"
          cols="20"
          fluid
          #text5
        ></textarea>
        <small
          style="color: #ff7193"
          *ngIf="submitted() && keyphraseRow()?.key_phrase_en == ''"
          ><b>Key Phrase (En) required.</b></small
        >
      </div>
    </div>
  </ng-template>

  <ng-template #footer>
    <p-button
      label="Cancel"
      [style]="{ color: '#ff7193' }"
      icon="pi pi-times"
      text
      (click)="hideDialog()"
    />
    <p-button
      [style]="{ 'background-color': '#5861ff' }"
      label="Save"
      icon="pi pi-check"
      (click)="saveRow()"
    ></p-button>
  </ng-template>
</p-dialog>
<p-confirmdialog />
<p-toast />
} @else {
  {{tableData$ | async}}
}
